import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Heart, ArrowRight, Clock, AlertCircle } from 'lucide-react';
import { usePricing } from '../hooks/usePricing';
export function Footer() {
  const checkoutUrl = 'https://kreanacrochet.com/cart/add?id=52738305032303&quantity=1';
  const {
    formattedPrice,
    formattedOriginalPrice,
    isLoading
  } = usePricing();
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  const [viewers, setViewers] = useState(22);
  const [spotsLeft, setSpotsLeft] = useState(12);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => {
        const change = Math.floor(Math.random() * 5) - 2;
        const next = prev + change;
        return Math.min(Math.max(next, 16), 30);
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsLeft(prev => {
        if (prev <= 3) return 3;
        return Math.random() > 0.6 ? prev - 1 : prev;
      });
    }, 15000);
    return () => clearInterval(interval);
  }, []);
  const maxSpots = 20;
  const progressPercent = (maxSpots - spotsLeft) / maxSpots * 100;
  return <footer className="bg-chocolate text-white/80" data-id="element-133">
      {/* Final CTA with product image */}
      <div className="py-10 md:py-16 border-b border-white/10" data-id="element-134">
        <div className="max-w-xl mx-auto px-4 text-center" data-id="element-135">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-136">
            <p className="font-heading text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-137">
              ¿Lista para tejer a tu mascota?
            </p>
            <p className="text-white/60 mb-8 text-sm max-w-md mx-auto" data-id="element-138">
              Tu compañero peludo merece ser inmortalizado. Empieza hoy con la
              colección completa.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="mb-6" data-id="element-139">
            <img src="https://cdn.magicpatterns.com/uploads/8VPmE57bCjoWcdR4zzicK2/20260225_1731_Image_Generation_simple_compose_01kjb7zbkpetat25nqp9xr0xsh_(1).png" alt="Colección completa: +60 Patrones Amigurumis de Mascotas con todos los bonos" className="w-full max-w-lg mx-auto rounded-xl shadow-2xl" data-id="element-140" />
          </motion.div>

          {/* Compact urgency triggers */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 mb-6 max-w-md mx-auto text-left" data-id="element-141">
            <div className="flex items-center justify-between text-sm mb-2" data-id="element-142">
              <span className="flex items-center gap-2 text-white/90 font-medium" data-id="element-143">
                <span className="relative flex h-2.5 w-2.5" data-id="element-144">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal opacity-75" data-id="element-145"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-teal" data-id="element-146"></span>
                </span>
                {viewers} personas viendo
              </span>
              <span className="flex items-center gap-1.5 text-copper font-bold" data-id="element-147">
                <Clock size={13} data-id="element-148" />
                {formatTime(timeLeft)}
              </span>
            </div>
            {/* Scarcity bar */}
            <div className="flex items-center gap-2 text-xs text-white/70 mb-1.5" data-id="element-149">
              <AlertCircle size={12} className="text-terracotta" data-id="element-150" />
              <span data-id="element-151">
                🔥 Solo{' '}
                <span className="text-terracotta font-bold" data-id="element-152">{spotsLeft}</span>{' '}
                cupos con descuento
              </span>
            </div>
            <div className="w-full bg-white/20 rounded-full h-2 overflow-hidden" data-id="element-153">
              <motion.div className="h-full bg-gradient-to-r from-terracotta to-red-500 rounded-full" initial={{
              width: '0%'
            }} animate={{
              width: `${progressPercent}%`
            }} transition={{
              duration: 1,
              ease: 'easeOut'
            }} data-id="element-154" />
            </div>
          </motion.div>

          {/* Price + CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="space-y-4" data-id="element-155">
            <div className="flex items-center justify-center gap-3" data-id="element-156">
              <span className="text-white/50 line-through text-lg" data-id="element-157">
                {isLoading ? '...' : formattedOriginalPrice}
              </span>
              <span className="text-3xl font-bold text-white" data-id="element-158">
                {isLoading ? '...' : formattedPrice}
              </span>
              <span className="bg-terracotta text-white text-xs font-bold px-2 py-0.5 rounded" data-id="element-159">
                70% OFF
              </span>
            </div>
            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="btn-pulse inline-flex items-center gap-2 px-10 py-4 bg-copper text-white rounded-full font-bold text-lg hover:bg-copper/90 transition-colors shadow-lg" data-id="element-160">
              Quiero mis patrones
              <ArrowRight size={18} data-id="element-161" />
            </a>
          </motion.div>
        </div>
      </div>

      {/* Footer links */}
      <div className="py-10" data-id="element-162">
        <div className="max-w-5xl mx-auto px-4" data-id="element-163">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-164">
            <div className="text-center md:text-left" data-id="element-165">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-2" data-id="element-166">
                <Heart size={14} className="text-copper fill-copper" data-id="element-167" />
                <span className="font-heading font-bold text-lg text-white" data-id="element-168">
                  KreanaCrochet
                </span>
              </div>
              <p className="text-xs text-white/40" data-id="element-169">
                Tejiendo recuerdos, una puntada a la vez.
              </p>
            </div>
            <div className="flex gap-6 text-xs font-medium text-white/50" data-id="element-170">
              <a href="#" className="hover:text-white transition-colors" data-id="element-171">
                Términos
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-172">
                Privacidad
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-173">
                Contacto
              </a>
            </div>
          </div>
          <div className="mt-8 pt-6 border-t border-white/10 text-center text-xs text-white/30" data-id="element-174">
            © {new Date().getFullYear()} KreanaCrochet. Todos los derechos
            reservados.
          </div>
        </div>
      </div>
    </footer>;
}